import { Routes, Route, Navigate } from "react-router-dom"
import SessionManagement from "./components/SessionManagement"
import Viewer from "./components/Viewer"
import { Fragment } from "react"
import { ToastContainer } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"

function App() {
  return (
    <Fragment>
      <Routes>
        <Route path="/" element={<SessionManagement />} />
        <Route path="/session/:session_id" element={<Viewer />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <ToastContainer position="top-right" />
    </Fragment>
  )
}

export default App
